<style lang="less" scoped>
  @import './index.less';
</style>
<template>
  <div style="width:1100px;margin:0 auto;overflow-x:auto;">
    <div class="member-info-container">
      <svg-icon class="member-icon" icon-class="member" />
      <div class="member-info">
        <div class="member-email">
          账号: {{currentUser.name}}
        </div>
        <div class="member-address">
          <el-button type="text">
            <router-link to="member-address">
              我的收货地址
            </router-link>
          </el-button>
          <el-button type="text" @click="handleLogout">退出</el-button>
        </div>
      </div>
    </div>
    <div class="member-orders">
      <el-tabs value="member-orders" v-model="activeName" @tab-click="tabClick">
        <el-tab-pane label="全部订单" name="allOrders" :lazy="true">
          <OrderListItem @cancelOrder="cancelOrder" v-for="(order, index) of collection" :key="index" :order="order"/>
        </el-tab-pane>
        <el-tab-pane label="待付款" :lazy="true" name="unpaidOrders">
          <OrderListItem  v-for="(order, index) of collection" :key="index"  @cancelOrder="cancelOrder" :order="order"/>
        </el-tab-pane>
        <el-tab-pane label="待发货" :lazy="true" name="unshippingOrders">
          <OrderListItem  v-for="(order, index) of collection" :key="index"  :order="order" />
        </el-tab-pane>
      </el-tabs>
      <div class="pagination">
        <pagination :total="total" :pagination="pagination" :changed="getOrders" />
      </div>
    </div>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import _ from 'lodash';
  import OrderListItem from "./components/OrderListItem";

  const { mapState: authMapState } = createNamespacedHelpers('auth')
  const { mapGetters } = createNamespacedHelpers('orders')

  const limit = 6

  export default {
    name: 'index',
    components: {OrderListItem},
    data() {
      return {
        activeName: 'allOrders',
      }
    },
    updated() {
    },
    methods: {
      cancelOrder() {
        const currentPage = this.pagination.currentPage
        this.getOrders({ pagination: { currentPage, limit } })
      },
      tabClick(tab, event) {
        localStorage.removeItem('currentPage')
        localStorage.removeItem('limit')
        localStorage.setItem('activeTabName', tab.name)
        this.activeName = tab.name
        this.getOrders()
      },
      handleLogout() {
        this.$store.dispatch('auth/logout')
        this.$router.replace({ name: 'login' })
      },
      async getOrders({ pagination = {limit} } = {}) {
        let query = {};
        switch (this.activeName) {
          case 'unpaidOrders':
            query.orderStatus = this.$enums.orderStatus.UNSETTLED
            query.payStatus = 110
            query.shippingStatus = this.$enums.shippingStatus.UNSHIPPED
            break;
          case 'unshippingOrders':
            query.payStatus = this.$enums.payStatus.PAID
            query.shippingStatus = this.$enums.shippingStatus.UNSHIPPED
            break;
          default:
            break;
        }

        const sort = {id: 'desc'}

        await this.$store.dispatch('orders/collection', {query, pagination, sort});
      },
      back() {
        const currentPage = localStorage.getItem('currentPage') ? localStorage.getItem('currentPage') : 0
        const limit = localStorage.getItem('limit') ? localStorage.getItem('limit') : 0
        const activeTabName = localStorage.getItem('activeTabName') ? localStorage.getItem('activeTabName') : 'allOrders'
        this.activeName = activeTabName
        this.getOrders({ pagination: { currentPage, limit } })
      }
    },
    mounted() {
      this.getOrders()
      window.addEventListener('load', this.back)
    },
    beforeDestroy() {
      localStorage.removeItem('currentPage')
      localStorage.removeItem('limit')
      localStorage.removeItem('activeTabName')
    },
    computed : {
      ...authMapState([
        'currentUser'
      ]),

      ...mapGetters([
        'collection',
        'total',
        'pagination']
      ),
    },
    watch : {

    }
  };
</script>


